<template>
  <v-dialog v-model="isOpen" max-width="290">
    <v-card>
      <v-card-title class="headline">Are you sure?</v-card-title>
      <v-card-text class="confirm-nonlisting-modal" v-if="isOpen">doxo works best when you add all your bills for every type of service. Are you sure you have no {{ serviceType.name }} provider?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat="flat" @click.prevent="cancelNonListing">Cancel</v-btn>
        <v-btn color="primary" flat="flat" @click.prevent="confirmNonListing">I'm sure</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState('recommendations', ['pendingNonListing']),
      isOpen: {
        get () {
          return !!this.pendingNonListing
        },
        set () {
          this.$store.dispatch('recommendations/cancelNonListing')
        }
      },
      serviceType () {
        return this.pendingNonListing
      }
    },
    methods: {
      cancelNonListing () {
        this.$store.dispatch('recommendations/cancelNonListing')
      },
      confirmNonListing () {
        this.$store.dispatch('recommendations/createNonListing', this.serviceType)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/ConfirmNonlisting.vue